import CachedIcon from '@mui/icons-material/Cached';
import SettingsIcon from '@mui/icons-material/Settings';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import IntegrationConfigurationLayout from 'pages/integrations/IntegrationConfigurationLayout';
import { selectJamfAssetsCount } from 'store/slices/integrations/jamf/assets/selectors';

import { useJamfBetaPermissionCheck } from '../_shared/hooks';
import JamfStatsCardGroup from '../cards/JamfStatsCardGroup';
import SyncLoadingCard from '../cards/SyncLoadingCard';
import JamfAssetsTable from '../tables/JamfAssetsTable';
import {
  useGetJamfLastSync,
  useHandleErrorNotifications,
  useHandleSettingsClick,
  useHandleSuccessNotifications
} from './hooks';
import { ContainerSx, JamfAssetsTitleSx, LastSyncTitleSx, SettingsButtonSx } from './styles';

const JamfDetails = () => {
  useHandleErrorNotifications();
  useHandleSuccessNotifications();
  useJamfBetaPermissionCheck();
  
  const {
    lastSyncDate,
    syncedCount,
    unsyncedCount,
    isProcessing,
    isInitialized
  } = useGetJamfLastSync();
  
  const jamfAssetsCount = useSelector(selectJamfAssetsCount);
  const handleSettingsClick = useHandleSettingsClick();

  const syncButton = (
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<CachedIcon />}
      disabled={true}
      sx={SettingsButtonSx}
      data-testid="jamf-sync-button"
    >
      Sync now
    </Button>
  );

  const settingsButton = (
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<SettingsIcon />}
      onClick={handleSettingsClick}
      sx={SettingsButtonSx}
      data-testid="jamf-settings-button"
    >
      Settings
    </Button>
  );

  return (
    <Stack sx={ContainerSx} data-testid="jamf-settings-page">
      <IntegrationConfigurationLayout
        title="Jamf"
        type="details"
        connected={isInitialized}
        controls={[
          // TODO: add back sync button when we have a way to trigger a sync
          // syncButton, 
          settingsButton,
        ]}
        data-testid="jamf-details-layout"
      >
        <br />
        <br />
        <Typography sx={LastSyncTitleSx} data-testid="jamf-last-sync-title">
          Last Sync
        </Typography>
        <JamfStatsCardGroup 
          data-testid="jamf-stats"
          lastSyncDate={lastSyncDate}
          syncedCount={syncedCount}
          unsyncedCount={unsyncedCount}
          processing={isProcessing}
        />
        <br />
        <br />
        {isProcessing ? (
          <SyncLoadingCard data-testid="jamf-sync-loading" />
        ) : (
          <>
            <Typography sx={JamfAssetsTitleSx} data-testid="jamf-assets-title">
              All assets with Jamf ID in allwhere ({jamfAssetsCount})
            </Typography>
            <JamfAssetsTable />
          </>
        )}
      </IntegrationConfigurationLayout>
    </Stack>
  );
};

export default JamfDetails;
